import { render } from "./KanoonChildKanoonCard.vue?vue&type=template&id=f12e68a6"
import script from "./KanoonChildKanoonCard.vue?vue&type=script&lang=js"
export * from "./KanoonChildKanoonCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"KanoonChildKanoonCard.vue"]])

export default __exports__